import React, { createContext, useContext, useState } from 'react';
import executivePro from '../assets/images/executive_pro.png';
import classicAviator from '../assets/images/classic_aviator.png';
import retroRound from '../assets/images/retro_round.png';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([
    {
      id: 1,
      badge: 'BEST SELLER',
      badgeColor: 'text-[#D83232]',
      title: 'Executive Pro',
      variant: 'Frame: Midnight Matte | Lens: Blue Light Filter',
      price: '249.00',
      quantity: 1,
      image: executivePro
    },
    {
      id: 2,
      badge: 'PRESCRIPTION READY',
      badgeColor: 'text-[#2A3182]',
      title: 'Classic Aviator',
      variant: 'Frame: Brushed Gold | Lens: Clear UV400',
      price: '185.00',
      quantity: 1,
      image: classicAviator
    },
    {
      id: 3,
      badge: 'NEW ARRIVAL',
      badgeColor: 'text-[#D83232]',
      title: 'Retro Round',
      variant: 'Frame: Tortoise Shell | Lens: Gradient Grey',
      price: '199.00',
      quantity: 1,
      image: retroRound
    }
  ]);

  const addToCart = (product) => {
    setItems((prevItems) => {
      const existing = prevItems.find((item) => item.id === product.id);
      if (existing) {
        return prevItems.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + (product.quantity || 1) } : item
        );
      }
      return [...prevItems, { ...product, quantity: product.quantity || 1 }];
    });
  };

  const updateQuantity = (id, delta) => {
    setItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === id) {
          const newQuantity = Math.max(1, item.quantity + delta);
          return { ...item, quantity: newQuantity };
        }
        return item;
      })
    );
  };

  const removeItem = (id) => {
    setItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const cartCount = items.reduce((count, item) => count + item.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, updateQuantity, removeItem, cartCount }}>
      {children}
    </CartContext.Provider>
  );
};
